const mutations = {
  setModels(state, data) {
    state.correlativass = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.correlativas = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.correlativass.unshift(model);
  },

  updateModel(state, model) {
    const index = state.correlativass
      .map(function (item) {
        return item.id;
      })
      .indexOf(model.id);
    state.correlativass.splice(index, 1, model);
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.correlativass
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.correlativass.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
